module.exports = __webpack_public_path__ + "resources/images/knab-251259c51acac7c5eee3676b687cae9b-cache.png";